enum UserRole {
  ADMIN = "admin",
  USER = "user",
}

export { UserRole };